import React from "react";
import {
    IconDocumentLinedGrid, IconScheduleTable
} from "../../../../../../components/buttons/IconButtons";
import { EMPTY_VALUES } from "../../../../../../Apis/functions";
import SummaryListCard from "../../../../../../components/Summary/SummaryListCard";
import dayId from "../../../../../../hooks/dayId";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azapata@ibl.mx
 *
 * Schedules container for the work shift summary. Lists the buffered schedules
 * (zone + day + time range) over the shared SummaryListCard.
 */
const SummaryContainerSchedules = ({ t, selected = [] }) => {

    const renderValue = (item) => (
        <div className={"col-12 d-flex justify-content-end align-items-baseline p-0 pr-3"}>
            <p className={"fs-12px"}>
                {`${dayId(item?.dayId)} · ${item?.from || EMPTY_VALUES.DEFAULT} - ${item?.to || EMPTY_VALUES.DEFAULT}`}
            </p>
        </div>
    );

    return (
        <SummaryListCard
            headerIcon={IconDocumentLinedGrid}
            title={t('schedules')}
            emptyText={t('no_information')}
            avatarIcon={IconScheduleTable}
            selected={selected}
            getKey={(item, index) => item.tempId || index}
            getLabel={(item) => item.zoneName}
            renderValue={renderValue}
            overflowLabel={'total_added_schedules'}
            t={t}
        />
    )

}

export default SummaryContainerSchedules
